export const required = <T>(value: T, message = 'Обязательное поле') => {
    if (!value) {
        return message;
    }
    return '';
};
